import {
    SET_ASSET_SUB_TYPE,
} from "./AssetSubTypeType";
  
const reducer = (state = [], action: any) => {
    switch (action.type) {
        case SET_ASSET_SUB_TYPE:
            return {
                ...state,
                AssetSubType: action.assetSubType,
            };
        default:
            return state;
    }
};

export default reducer;
